<template>
  <v-sheet class="pe-2 pb-2" height="100%" width="100%">
    <div ref="schedulerContainer" class="AIVA_Scheculer h-100"></div>
    <div class="dhx_minical_icon" id="dhx_minical_icon">&nbsp;</div>
    <RecurringEvent ref="recurringEvent"></RecurringEvent>
  </v-sheet>
</template>

<script>
/* eslint-disable */
import RecurringEvent from '@/features/Task/components/RecurringEvent.vue';
import { log, warn, error } from '@/utils/debugLogger';
export default {
  name: 'app-scheduler',
  data() {
    return {
      dialogVisible: false,
      lastClickTime: 0
    };
  },
  methods: {
    initializeScheduler() {
      this.$store.dispatch('SCHEDULER/GET', { typeId: this.taskTypeId });
    },
    displaySchedule() {
      scheduler.config.xml_date = '%Y-%m-%d %H:%i:%s';
      scheduler.templates.xml_date = scheduler.date.str_to_date('%Y-%m-%d %H:%i:%s');
      scheduler.templates.xml_format = scheduler.date.date_to_str('%Y-%m-%d %H:%i:%s');

      scheduler.config.header = [
        'prev',
        'today',
        'next',
        'date',
        {
          view: 'minicalendar',
          click: function () {
            if (scheduler.isCalendarVisible()) {
              scheduler.destroyCalendar();
            } else {
              scheduler.renderCalendar({
                position: this,
                date: scheduler.getState().date,
                navigation: true,
                handler: function (date, calendar) {
                  scheduler.setCurrentView(date);
                  scheduler.destroyCalendar();
                },
              });
            }
          },
        },
        'day',
        'week',
        'month',
      ];

      scheduler.plugins({
        minical: true,
        recurring: true,
      });

      scheduler.config.prevent_cache = true;

      scheduler.config.drag_resize = false;
      scheduler.config.drag_create = false;
      scheduler.config.dblclick_create = false;
      scheduler.config.occurrence_timestamp_in_utc = true;
      scheduler.config.include_end_by = true;
      scheduler.config.repeat_precise = true;
      scheduler.init(this.$refs.schedulerContainer, new Date(), 'month');
      scheduler.updateView();

      const formatMonthScale = scheduler.date.date_to_str('%D');

      scheduler.templates.month_scale_date = function (date) {
        return formatMonthScale(date);
      };

      if (!scheduler.isInitialized) {
        scheduler.isInitialized = true;
        scheduler.createDataProcessor((entity, action, data, id) => {
          let ev = {
            entity,
            action,
            data,
            id,
          };
          log(`ev`, ev);
          this.handleSchedulerEvent(ev);
        });
      }

      this.initializeScheduler();

      scheduler.attachEvent("onEmptyClick", function (date, e) {
        const currentTime = new Date().getTime();
        if (currentTime - this.lastClickTime < 300) {
          self.$refs.recurringEvent.openDialog(null, new Date(date));
        }
        this.lastClickTime = currentTime;
      });

      scheduler.attachEvent("onBeforeDrag", function (id, mode, e){
        if (mode === "move") {
          let eventID = id.match(/^[^#]+/)[0];
          let event = scheduler.getEvent(eventID);
          return event && !event.rec_type;
        }
      });

      let self = this;
      
      scheduler.attachEvent('onDblClick', function (id, e) {
        let eventID = id.match(/^[^#]+/)[0];
        let event = scheduler.getEvent(eventID);
        if (event) {
          self.$refs.recurringEvent.openDialog(eventID, event.start_date, event.end_date);
        }
      });

      scheduler.showLightbox = function (id) {
        let eventID = '';
        if (typeof id === 'string') {
          eventID = id.match(/^[^#]+/)[0];
        } else {
          eventID = null;
          return;
        }

        self.$refs.recurringEvent.openDialog(eventID);
      };
    },
    handleSchedulerEvent(ev) {
      log(`ev`, ev);
      // TODO:: Handle the event
      if (ev.action === 'inserted') {
        // this.$store.dispatch('SCHEDULER/CREATE', ev.data);
      } else if (ev.action === 'update') {
        let eventID = ev.id.match(/^[^#]+/)[0];
        let event = scheduler.getEvent(eventID);

        if (event) {
          event.start_date = ev.data.start_date;
          event.end_date = ev.data.end_date;
          event.text = ev.data.text;
          event.rec_type = ev.data.rec_type;
          event.event_length = ev.data.event_length;
          event.event_length_unit = ev.data.event_length_unit;
          event.recurrence_id = ev.data.recurrence_id;
        }

        this.$store.dispatch('SCHEDULER/UPDATE', event);
      } else if (ev.action === 'deleted') {
        // this.$store.dispatch('SCHEDULER/DELETE', ev.id);
      }
    },
  },
  computed: {
    events: {
      get() {
        return this.$store.getters['SCHEDULER/GET_SCHEDULER_EVENTS'];
      },
      set(value) {
        this.$store.commit('SCHEDULER/SET_SCHEDULER_EVENTS', value);
      },
    },
    taskTypeId() {
      return this.$route.params?.taskTypeId || this.$route.query?.taskTypeId;
    },
  },
  mounted() {
    this.displaySchedule();
  },
  components: {
    RecurringEvent,
  },
  watch: {
    '$vuetify.theme.dark': {
      handler: function (value) {
        scheduler.setSkin(value ? 'dark' : '');
      },
      deep: true,
      immediate: true,
    },
    events: {
      handler: function () {
        log(
          `%c🔃 Refreshing Scheduler`,
          'color: green; font-size: 16px; font-weight: 700;',
        );

        if (this.events.length) {
          scheduler.clearAll();

          // Create a immutable copy of the events
          // let events = JSON.parse(JSON.stringify(this.events));
          let events = structuredClone(this.events);
          scheduler.parse(events, 'json');
        } else {
          scheduler.clearAll();
        }
      },
      immediate: true,
    },

    $route: {
      handler(route) {
        this.initializeScheduler();
      },
    },
  },
};
</script>

<style lang="scss">
:root {
  --dhx-scheduler-timescale-today-background: var(--v-light_Primary3-base);
  --dhx-scheduler-event-blue: linear-gradient(270deg, var(--v-primary-lighten1) 0%, var(--v-primary-base) 100%);
}

:root[data-scheduler-theme='dark'] {
  --dhx-scheduler-base-colors-background: var(--v-bg2-base);
}

.AIVA_Scheculer {
  &.dhx_scheduler_month .dhx_cal_event_line {
    margin-top: 4px;
  }

  .dhx_cal_navline {
    padding: 0px;


    .dhx_cal_tab_segmented.dhx_cal_tab_first {
      border-radius: 7px 0px 0px 7px;
    }

    .dhx_cal_tab {
      background-color: var(--v-light_Primary3-base);
      border: 1px solid var(--v-light_Primary3-base);
      color: var(--v-primary-base);
    }

    .dhx_cal_tab.active {
      background-color: var(--v-bg_force_white-base);
      border: 0.5px solid #91ac6a;
      border-radius: 7px;
      // box-shadow: 0px 3px 1px 0px #0000000a;

      box-shadow: 0px 0px 8px 0px #0000000d;
    }

    .dhx_cal_today_button {
      border: 1px solid var(--v-primary-base);
      color: var(--v-primary-base);

      &:hover {
        background-color: var(--v-light_Primary3-base);
      }
    }

    .dhx_cal_today_button.active {
      background-color: var(--v-primary-base);
    }
  }

  .dhx_cal_event .dhx_menu_icon {
    color: var(--v-primary-base);
  }

  .dhx_event_resize.dhx_footer {
    display: none;
  }

  .dhx_cal_header {
    border-radius: 8px 8px 0px 0px;
    height: 48px !important;
    // border-top: 1px solid #ededed;

    // .dhx_scale_bar:first-child {
    //   border-left: 1px solid #ededed;
    // }
    .dhx_scale_bar {
      justify-content: space-between;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      text-align: left;
      height: 48px !important;
      padding: 12px;
      background-color: #ededed66;
      border-left: 0.5px solid #ededed;
      border-right: 0.5px solid #ededed;
      border-top: 1px solid #ededed;
      color: var(--v-black-base);
    }
  }

  .dhx_cal_data {

    // border: 1px solid #ededed;
    .dhx_cal_month_row {
      .dhx_cal_month_cell:first-child {
        border-left: 1px solid #ededed;
      }
    }

    .dhx_cal_month_cell {
      border-right: 1px solid #ededed;
      border-bottom: 1px solid #ededed;

      .dhx_month_head {
        justify-content: flex-start;
        font-size: 19px;
        font-weight: 500;
        line-height: 11px;
        color: var(--v-normal-grey-base);
        padding: 8px 5px;
      }

      .dhx_month_body {}
    }

    .dhx_cal_month_cell.dhx_now {
      .dhx_month_head {
        color: var(--v-primary-base);
      }
    }

    .dhx_cal_event_clear {
      padding: 0px 5px;
      max-height: 20px;
      margin-top: 5px;
      border-left: 5px solid var(--v-primary-base);
      // bcd9a5
      background-color: var(--v-light_dark_green-base);
      color: var(--v-bg_force_black-base);

      &::before {
        content: none;
      }
    }
  }
}

// .theme--dark {
//   .dhx_cal_data {
//     .dhx_cal_month_cell.dhx_now {
//       .dhx_cal_event_clear {
//         background-color: var(--v-very_light_green-base);
//       }
//     }
//     .dhx_cal_event_clear {
//     }
//   }
// }</style>
